<template>
  <Transition>
    <div class="base-modal" v-if="isShow" :class="props.customClass">
      <div class="base-modal__wrapper">
        <div class="base-modal__logo">
          <router-link v-if="isLogo" class="header__logo-link pt-5" to="/" target="_blank">
            <div class="flex justify-center items-center text-iconColor">
              <DougJonesMainLogo :isDark="isDarkMode" class="w-32 md:w-32 lg:w-48 xl:w-[200px] h-auto" />
            </div>
          </router-link>
          <div class="base-modal__welcomeText" v-if="isLogo">
            <h1 class="text-2xl md:text-2xl font-bold mb-[5px] mt-[28px] lh-0-8 welcome-text">
              Welcome!
            </h1>
            <h6 class="text-md md:text-lg font-bold mb-[1px]" :style="{ color: 'var(--subtitle-login)' }">
              Log in to continue
            </h6>
          </div>
        </div>

        <div class="flex flex-col justify-center items-center gap-1 w-320px pb-3">
          <div class="base-modal__container" :class="containerClass">
            <span v-if="isCloseActive" class="base-modal__close" @click="modalHide" />
            <div class="base-modal__body">
              <slot name="body"></slot>
            </div>
          </div>
          <!-- <div>
            <h6 class="text-foregroundPrimary font-normal text-[16px]">Or</h6>
          </div>
          <div class="continue-btn" @click="continueWithFrequency">
            <span class="font-normal text-[15px] pr-4">Continue with</span>
            <FrecuencyLogo class="w-[80px] scale-110" />
          </div> -->
          <!-- old inline: style="color: #5BA2B2;" → moved to .modal-footer-text in scoped CSS -->
          <!-- <div class="modal-footer-text text-md font-normal text-center pb-5 pt-2">
            Don’t have an account? <br>
            old inline: style="color: #4849A1;" → moved to .modal-signup-link in scoped CSS
            <a href="/sign-up" class="modal-signup-link text-[15px] hover:underline font-bold">Sign Up</a>
          </div> -->
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { computed, onBeforeUnmount, watch } from 'vue';
// import DougJonesMainLogo from "@/components/Icons/DougJonesMainLogo.vue";
import DougJonesMainLogo from "@/components/Icons/LaunchPadLogo.vue";
import FrecuencyLogo from "@/components/Icons/FrecuencyLogo.vue";
import { useRouter } from 'vue-router'
import { useThemeScheme } from "@/composables/useThemeSchema";
const { isDarkMode } = useThemeScheme();
const router = useRouter();

const emit = defineEmits(["update:isShow"]);
const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  subTitle: {
    type: String,
    default: "",
  },
  isLogo: {
    type: Boolean,
    default: false,
  },
  isShow: {
    type: Boolean,
    default: false,
  },
  isCloseActive: {
    type: Boolean,
    default: false,
  },
  isShadow: {
    type: Boolean,
    default: false,
  },
  isSucces: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: "md", // sm | md | lg | xl
    validator: (v) => ["sm", "md", "lg", "xl"].includes(String(v)),
  },
  customClass: {
    type: String,
    default: "",
  },
  backgroundColor: {
    type: String,
    default: '', // Use default SCSS var if not passed
  },

});

const containerClass = computed(() => {
  return [
    {
      "base-modal__container_is-shadow": props.isShadow,
      "base-modal__container_is-succes": props.isSucces,
      [`base-modal__container_size-${props.size}`]: true,
    },
  ];
});

const modalHide = () => {
  emit("update:isShow", false);
  document.body.style.overflow = "auto";
};

// Lock background scroll while modal is open; restore on close/unmount
const restoreBodyOverflow = () => {
  const prev = (document.body.dataset.prevOverflow ?? "");
  document.body.style.overflow = prev;
  delete document.body.dataset.prevOverflow;
};



onBeforeUnmount(() => {
  restoreBodyOverflow();
});
// Continue with Frequency
const continueWithFrequency = () => {
  // Use SIWF login URL if available, otherwise fallback to sign-in-with-x route
  const siwfUrl = import.meta.env.VITE_SIWF_LOGIN_URL;
  if (siwfUrl && siwfUrl !== 'undefined') {
    window.location.href = siwfUrl;
  } else {
    router.push('/sign-in-with-x');
  }
}
</script>

<style lang="scss" scoped>
.base-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: flex-start; // Changed from center to flex-start
  padding: 20px;
  overflow-y: auto; // Added for scrollable modal

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    justify-content: flex-start; // Changed from center
    width: 100%;
    max-width: 100%;
    margin: auto; // Added for centering
    padding: 40px 0; // Added vertical padding
  }
  
  &__logo {
    height: auto;
    /* Changed: Was 30%, which could compress top; now flexible */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.5rem;
    /* Added: Small balanced margin instead of fixed height */
  }

  &__welcomeText {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 510px;
    margin: 0 auto;
    /* Simplified */
    // padding: 28px;
    /* Changed: Equalized padding (was 3% 28px); use fixed for consistency */
    // background-color: var(--logi-modal);
    // box-shadow: var(--surface-shadow-sm, 0 2px 4px -2px rgba(0, 0, 0, 0.06)), 0 1px 2px rgba(0, 0, 0, 0.04);
    border-radius: 10px;
    max-height: calc(100vh - 48px);
    // overflow: auto;
    // overscroll-behavior: contain;
    // border: 1px solid var(--outline-reaction-bar);

    // Responsive: Equalize padding reductions
    @media (max-width: 768px) {
      max-width: 95vw;
      padding: 24px;
      /* Balanced */
      margin: 16px auto;
    }

    @media (max-width: 640px) {
      max-width: 96vw;
      padding: 20px;
      margin: 12px auto;
    }

    @media (max-width: 480px) {
      max-width: 98vw;
      padding: 16px;
      margin: 8px auto;
      border-radius: 8px;
    }

    @media (max-width: 360px) {
      max-width: 100vw;
      padding: 12px;
      margin: 4px auto;
      border-radius: 6px;
    }

    @media (max-width: 340px) {
      max-width: 100vw;
      padding: 10px;
      margin: 2px auto;
      border-radius: 4px;
    }

    // &_is-shadow {
    //   box-shadow: var(--surface-shadow-md, 0 10px 15px -3px rgba(0, 0, 0, 0.25));
    // }

    /* Size modifiers */
    &_size-sm {
      max-width: 480px;
    }

    &_size-md {
      max-width: 510px;
    }

    &_size-lg {
      max-width: 720px;
    }

    &_size-xl {
      max-width: 900px;
    }

    &_is-succes {
      opacity: 0.9;
      width: fit-content;
      padding: 20px 50px;
      box-shadow: 0px 10px 50px rgba(0, 0, 0, 0.2);

      @media (max-width: 640px) {
        padding: 16px 32px;
      }

      @media (max-width: 480px) {
        padding: 12px 24px;
      }

      .base-modal__header {
        .header__title {
          color: #29ab87;
        }
      }
    }
  }

  &__body {
    margin-bottom: 16px;
    /* Reduced from 30px to balance with top; adjust to match gap-2 (0.5rem=8px) + padding */
    width: 100%;
    /* Ensure full width for centered content */
    display: flex;
    flex-direction: column;
    align-items: center;
    /* Added: Center slotted content (e.g., OTP button) */
  }

  &__footer {
    display: flex;
    justify-content: center;
    margin-top: auto;
    /* Added: Pushes footer to bottom if needed, balances space */
  }

  &__close {
    opacity: 0.2;
    cursor: pointer;
    transition: opacity ease 0.5s;

    &:hover {
      opacity: 1;
    }

    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 10px;
      display: block;
      width: 16px;
      height: 2px;
      background: #000;
    }

    &::before {
      transform: rotate(45deg);
    }

    &::after {
      transform: rotate(-45deg);
    }
  }

  &__header {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    margin-bottom: 0.5rem;
    /* Added: Balanced margin */

    .header {
      &__logo-link {
        display: inline-block;
        text-decoration: none;
        margin-bottom: 10px;
        max-width: 160px;
      }

      &__title {
        text-align: center;
        font-weight: 500;
        font-size: 18px;
        color: #000000;
        margin-bottom: 10px;
      }

      &__subtitle {
        margin-bottom: -20px;
        color: #7c838d;
        display: inline-block;
        font-size: 12px;
        font-weight: 100;
        clip-path: inset(0 1.4ch 0 0);
        animation: l 2s steps(4) infinite;
      }

      @keyframes l {
        to {
          clip-path: inset(0 -1ch 0 0);
        }
      }
    }
  }

  @include _575 {
    &__wrapper {
      padding: 20px;
    }

    &__container {
      padding: 40px 20px;
      max-width: 100%;
    }

    &__body {
      width: 100%;
      margin-bottom: 20px;
    }

    &__footer {
      width: 100%;
    }
  }

  @include _380 {
    &__container {
      padding: 30px 10px;
    }
  }
}

// .base-modal__container {
//   overflow: hidden !important;
// }

.check {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center
}

/* OLD THEME – commented for new login redesign
.continue-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F4EEF3;
  border: 1px solid #F4E6FF;
  border-radius: 12px;
  padding: 10px 28px;
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 400;
  color: #4849A1 !important;
  width: 100%;
  max-width: min(604px, 90vw);
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;
  margin: 0.5rem 0;
}
.continue-btn:hover {
  background-color: #E6D9FB !important;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}
.continue-btn h6 {
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 600;
}
*/

/* NEW THEME – Continue with Farcaster button – dark */
.continue-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f4eef3;
  border: 1px solid #979498;
  border-radius: 12px;
  padding: 4px 24px;
  font-family: $poppins;
  font-size: 18px;
  font-weight: 400;
  color: #FFFFFF;
  max-width: min(604px, 90vw);
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transition: all 0.2s ease-in-out;
  margin: 0.5rem 0;
}

.continue-btn:hover {
  background-color: #48505a;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.45);
}

.continue-btn h6 {
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 600;
}

/* NEW THEME – footer text and signup link
   (inline styles removed from template; classes added instead) */
.modal-footer-text {
  color: #fff;    /* OLD inline was #5BA2B2 – overridable via :deep() in sign-in.vue */
}

.modal-signup-link {
  /* OLD: color: #FFAD00; */
  color: var(--interactive-01-new);    /* OLD inline was #4849A1 – overridable via :deep() in sign-in.vue */
  text-decoration: none;

  &:hover {
    /* OLD: color: rgba(84, 255, 229, 0.8); */
    color: var(--interactive-01-new);
    text-decoration: underline;
  }
}

/* --- Responsive: Continue button --- */
@media (max-width: 768px) {
  .continue-btn {
    font-size: 16px;
    padding: 9px 20px;
  }
}

@media (max-width: 480px) {
  .continue-btn {
    font-size: 15px;
    padding: 8px 16px;
    border-radius: 10px;
  }
}

@media (max-width: 375px) {
  .continue-btn {
    font-size: 14px;
    padding: 8px 12px;
    border-radius: 8px;
  }
}

.freq-logo {
  height: 28px;
  margin-left: 10px;
}

.text-sm.text-gray-700 {
  margin-top: 0.5rem;
  /* Added: Balance with other gaps */
}
@media (prefers-color-scheme: light) {
  .welcome-text{
    /* OLD: color: #001871 !important; */
    color: var(--interactive-01-new) !important;
  }
}
</style>
